var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Platform } from 'react-native';
import { NativeModules } from '../compatibility/NativeModules';
import { Metric } from '../metrics';
import { toErrorMessage } from '../util/ErrorHelper';
import TENANT_ID from '../config/TenantId';
import LogLevel from './LogLevel';
const LogNativeModule = NativeModules.LogModule;
const defaultLogOptions = {
    maxBackendLogLevel: LogLevel.Warn,
};
/**
 * Allowed usage example:
 * const logging = Log(“AtoZMobile”, Options);
 *
 * logging.info(“Logging Test”);
 *
 * try {throw new Error(‘Test error exception’)} catch(error){logging.error(`${error}`)}; or
 * try {throw new Error(‘Test error exception’)} catch(error){logging.error(“message”, { ERROR: error })};
 *
 * logging.info(“Logging context”, {context: ‘Add more context to the logs’});
 *
 */
const Log = (tenantId, options) => {
    const l = options === null || options === void 0 ? void 0 : options.maxBackendLogLevel;
    const includedValidValue = (l !== undefined) && (l !== null) && !Number.isNaN(+l);
    const maxBackendLogLevel = !includedValidValue ? defaultLogOptions.maxBackendLogLevel : l;
    function log(message, level, nativeMethod, optionalParams) {
        return __awaiter(this, void 0, void 0, function* () {
            if (maxBackendLogLevel < level) {
                return;
            }
            if (tenantId === undefined || tenantId === null) {
                return;
            }
            try {
                if (Platform.OS === 'web') {
                    yield nativeMethod(tenantId, message, optionalParams);
                }
                else {
                    yield nativeMethod(tenantId, message);
                }
            }
            catch (error) {
                Metric('LoggingFailed', TENANT_ID, {
                    attributes: {
                        error: toErrorMessage(error),
                    },
                }).put();
            }
        });
    }
    return {
        error(message, optionalParams) {
            log(message, LogLevel.Error, LogNativeModule.error, optionalParams);
        },
        warn(message, optionalParams) {
            log(message, LogLevel.Warn, LogNativeModule.warn, optionalParams);
        },
        info(message, optionalParams) {
            log(message, LogLevel.Info, LogNativeModule.info, optionalParams);
        },
        debug(message, optionalParams) {
            log(message, LogLevel.Debug, LogNativeModule.debug, optionalParams);
        },
    };
};
export { Log };
//# sourceMappingURL=Log.js.map